import React, { useContext } from "react"
import { Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { theme } from "../config"
import { Theme } from "../components/Context"
const useStyles = makeStyles(() => {
  return {
    Quantity: {
      background: props => props.red,
      fontWeight: "bold",
      borderRadius: "50%",
      width: 20,
      height: 20,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: props => props.white,
    },
  }
})

const Quantity = ({ className, quantity }) => {
  const color = theme(useContext(Theme))
  const classes = useStyles(color)
  return <Box className={`${classes.Quantity} ${className}`}>{quantity}</Box>
}

export default Quantity
